/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type api_updateBeneficiaryEmploymentRequest = {
    beneficiary_employment_id?: number;
    beneficiary_id?: number;
    country_calling_code?: number;
    country_id?: number;
    email?: string;
    employer_name?: string;
    employment_type_id?: number;
    end_date?: string;
    hours_per_week?: number;
    is_current?: boolean;
    job_title?: string;
    municipality?: string;
    phone?: string;
    region?: string;
    role_details?: string;
    sector?: string;
    sector_type?: api_updateBeneficiaryEmploymentRequest.sector_type;
    seniority_level_id?: number;
    start_date?: string;
    subject_area_id?: number;
};
export namespace api_updateBeneficiaryEmploymentRequest {
    export enum sector_type {
        PUBLIC = 'public',
        PRIVATE = 'private',
        NON_PROFIT = 'non_profit',
        INTERNATIONAL_ORGANISATION = 'international_organisation',
        ACADEMIC_RESEARCH = 'academic_research',
    }
}

